import { render, staticRenderFns } from "./btn-text-secondary2.vue?vue&type=template&id=0fa8b3e3&scoped=true&"
import script from "./btn-text-secondary2.vue?vue&type=script&lang=js&"
export * from "./btn-text-secondary2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa8b3e3",
  null
  
)

export default component.exports